// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonOutlined_button__GkXP4"};